import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import get from 'lodash/get';
import isNull from 'lodash/isNull';
import { AdminUserAgent } from '../../../api/adminUserAgent'
import { setAuthError } from '../../../reducers/error'
import { setUserConfiguration, setUserInitialConfiguration } from '../../../reducers/user'
import { getTokenFromStorage } from '../../../utils'
import { RecruiterBlockerScreen } from '../../warning-screens'

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState({
    authPassed: false,
    currentUser: null,
    isLimitedAccessScreenRendered: ""
  });

  const dispatch = useDispatch();
  const errorMessage = useSelector((state) => state.errorObserver.authError);
  const navigate = useNavigate();

  const fetchCurrentUser = async () => {
    try {
      const { data } = await AdminUserAgent.getCurrentUser(getTokenFromStorage());
      const hasProvenEmailOwnership = get(data, "is_email_verified") || get(data, "is_viewer");

      if (!hasProvenEmailOwnership) {
        navigate('/sign-in');
        return;
      }

      const isAllegedRecruiter = get(data, "is_alleged_recruiter", false);

      setState((prev) => ({
        ...prev,
        isLimitedAccessScreenRendered: isAllegedRecruiter,
        currentUser: isAllegedRecruiter !== true ? data : null
      }));
    } catch (error) {
      setState((prev) => ({ ...prev, authPassed: false }));
      dispatch(setAuthError(error?.response?.data?.detail));
      navigate('/sign-in');
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, [window.location.href]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const html = document.documentElement;
    const body = document.body;
    html.style.overflow = '';
    body.style.overflow = '';
    body.style.overflow = 'hidden scroll';
    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    const token = getTokenFromStorage();
    if (!token) navigate('/sign-in');

    if (state.isLimitedAccessScreenRendered !== true && !isNull(state.currentUser)) {
      dispatch(setUserInitialConfiguration(state.currentUser));
      dispatch(setUserConfiguration(state.currentUser));
      setState((prev) => ({ ...prev, authPassed: true }));
    }
  }, [state.isLimitedAccessScreenRendered, JSON.stringify(state.currentUser)]);

  if (state.isLimitedAccessScreenRendered === true) {
    return <RecruiterBlockerScreen />;
  }

  return state.authPassed ? children : <span>{errorMessage ?? ""}</span>;
};

export default ProtectedRoute
